import { styled, Tab } from '@material-ui/core';

export const EditProfileMediaTabItem = styled(Tab)(({ theme }) => ({
  fontSize: 10,
  [theme.breakpoints.up(450)]: {
    fontSize: 12,
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: 14,
  },
}));
